import styled from 'styled-components';

import colors from 'themes/Main';

const { white, gray01, gray03, gray04 } = colors;

export const Filter = styled.input.attrs({
  type: 'text',
})`
  width: ${({ width }) => (width ? `${width}px` : '100%')};
  height: 50px;
  padding: 16px;
  background-color: ${({ transparent }) =>
    !transparent ? white : 'transparent'};
  border-radius: 5px;
  border: 0;
  color: ${gray01};
  font-size: 14px;
  border: ${({ transparent }) => (!transparent ? 0 : `1px solid ${gray03}`)};
  box-shadow: ${({ transparent }) =>
    !transparent
      ? '0px 3px 5px rgba(219, 219, 219, 0.2), 0px 1px 18px rgba(219, 219, 219, 0.12), 0px 6px 10px rgba(219, 219, 219, 0.14)'
      : 'none'};

  &:disabled {
    opacity: 0.6;
  }

  &::placeholder {
    color: ${gray04};
    font-size: 14px;
  }
`;
